import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./styles.css";
// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import { useGetSliderMutation } from "../../RTK/Slices/Slices/apiSliceMeat";
import { useEffect } from "react";

function Carousel() {
  const [getSliders, { data }] = useGetSliderMutation();

  useEffect(() => {
    getSliders(); // تنفيذ الطلب عند التحميل
  }, [getSliders]);

  const imgSliders = data?.data || [];
  if (data && imgSliders.length === 0) return null; // مفيش سلايدر

  return (
    <div className="h-[15vh] lg:h-[30vh] Carousel">
      <Swiper
        key={imgSliders?.length}
        slidesPerView={1}
        spaceBetween={30}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={imgSliders.length > 1}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper h-[15vh] lg:h-[30vh] "
      >
        {imgSliders?.map((Slider) => (
          <SwiperSlide key={Slider.id}>
            <img
              className="object-contain lg:object-fill"
              src={Slider.image_url}
              alt={Slider.title}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Carousel;
